module.exports = __webpack_public_path__ + "img/medicine_guide.1e8c3f7c.svg";